var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleetShowers(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.763 5.83C21.331 2.307 17.967 0 14.125 0 8.955 0 4.75 4.206 4.75 9.375v.078C2.094 9.9 0 12.28 0 15.063c0 3.101 2.586 5.624 5.688 5.624h3.75V23.5a.937.937 0 101.874 0v-2.813h9.376V23.5a.937.937 0 101.875 0v-2.813H24.5c4.135 0 7.5-3.364 7.5-7.5 0-4.685-4.45-8.52-9.237-7.357zM10.375 26.313a.937.937 0 00-.938.937v3.813a.937.937 0 101.876 0V27.25a.937.937 0 00-.938-.938zM21.625 26.313a.937.937 0 00-.938.937v3.813a.937.937 0 101.875 0V27.25a.937.937 0 00-.937-.938z",
    fill: "#2CACD7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleetShowers);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "2414fea8673f925879a3047a0ef21835.svg";
export { MemoForwardRef as ReactComponent };